import React from 'react';

import styles from '../styles/common/LoadingSpinner.module.scss';

function LoadingSpinner(): React.ReactElement {
  return (
    <div className={styles['loading-wrapper']}>
      <div className={styles['loading-ellipsis']}>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default LoadingSpinner;
